import { combineReducers } from "redux"
import notifications from "./notificationReducer";

export default combineReducers({
   notifications
});